import { render } from "./vlabelmanage.vue?vue&type=template&id=553e84f2&scoped=true"
import script from "./vlabelmanage.vue?vue&type=script&lang=js"
export * from "./vlabelmanage.vue?vue&type=script&lang=js"

import "./vlabelmanage.vue?vue&type=style&index=0&id=553e84f2&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-553e84f2"]])

export default __exports__